import React, { createContext, useContext, useEffect, useMemo, useReducer, useState } from "react";
import { serverBase } from "../utility/axios";

const studyYearContext = createContext();
const initialStudyYearContext = null;

const studyYearReducer = (state, action) => {
  switch (action.type) {
    case "SET_STUDY_YEAR":
      return action.payload;
    case "UNSET_STUDY_YEAR":
      return initialStudyYearContext;
    default:
      return initialStudyYearContext;
  }
};

export const StudyYearProvider = (props) => {
  const [state, dispatch] = useReducer(studyYearReducer, initialStudyYearContext);
  const value = useMemo(() => [state, dispatch], [state]);
  return <studyYearContext.Provider value={value} {...props} />;
};

export const useStudyYear = () => {
  const context = useContext(studyYearContext);
  if (!context) {
    throw new Error(`useTask must be used within a MoneyRequestProvider`);
  }
  const [state, dispatch] = context;
  const getStudyYear = () => {
    serverBase
      .get(`study-year/list`)
      .then((res) => {
        dispatch({ type: "SET_STUDY_YEAR", payload: res.data });
      })
      .catch((err) => {
        if (err.response) return [];
      });
  };
  const dumpAllStudyYear = () => {
    dispatch({ type: "UNSET_STUDY_YEAR" });
  };
  return {
    studyYear: state,
    getStudyYear,
    dumpAllStudyYear,
    currentStudyYear: state?.length ? state[0] : {},
  };
};

export const withStudyYearHOC = (Component) => {
  return (props) => {
    const studyYear = useStudyYear();

    return <Component studyYear={studyYear} {...props} />;
  };
};
